/* eslint-disable react/prop-types */
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { Col, FlexboxGrid } from 'rsuite';
import SelectInput from '~/components/selectInput/SelectInput';
import api from '~/services/api';

export default function SelectGrupo({ setForm, form }) {
  const [companyData, setCompanyData] = useState([{}]);
  const [groupData, setGroupData] = useState([{}]);
  useEffect(() => {
    async function getData() {
      const params = {
        skip: 0,
        take: 1000,
      };
      await api
        .get(`/Pessoa/GetPessoaPaginado?${qs.stringify(params)}`)
        .then((response) => {
          const { data } = response.data;
          setCompanyData(data);
        });
    }
    getData();
  }, []);

  useEffect(() => {
    async function getData() {
      const params = {
        idEmpresa: form.idPessoaEmpresa,
        skip: 0,
        take: 1000,
      };
      await api
        .get(`/Grupo/GetByEmpresa?${qs.stringify(params)}`)
        .then((response) => {
          const { data } = response.data;
          setGroupData(data);
        });
    }
    getData();
  }, [form.idPessoaEmpresa]);

  return (
    <FlexboxGrid align="top" style={{ marginTop: '16px' }}>
      <FlexboxGrid.Item componentClass={Col} colspan={24} md={12}>
        <SelectInput
          margin="0"
          width="100%"
          label="Selecione a empresa"
          form={form}
          valueKey="idPessoaEmpresa"
          labelKey="razaoSocialNome"
          setForm={setForm}
          value={form.idPessoaEmpresa}
          options={companyData}
          placeholder="Escolha uma opção"
          state="idPessoaEmpresa"
          onChange={() => {}}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col} colspan={24} md={12}>
        <SelectInput
          margin="0"
          width="100%"
          label="Selecione o grupo"
          form={form}
          valueKey="id"
          labelKey="nome"
          setForm={setForm}
          value={form.id}
          options={groupData}
          placeholder="Escolha uma opção"
          state="idGrupo"
          disabled={!form.idPessoaEmpresa}
          onChange={() => {}}
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
}
